import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

export default function useTaxAnalytics({
  endpoint = "/api/analytics/taxes",
  fromISO,
  toISO,
  state,
} = {}) {
  const qs = useMemo(() => {
    const params = new URLSearchParams();
    if (fromISO) params.set("from", fromISO);
    if (toISO) params.set("to", toISO);
    if (state) params.set("state", state);
    return params.toString();
  }, [fromISO, toISO, state]);

  const fetchAnalytics = async () => {
    const res = await fetch(`${endpoint}${qs ? `?${qs}` : ""}`, {
      credentials: "include",
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  };

  const queryKey = useMemo(
    () => ["analytics", endpoint, qs],
    [endpoint, qs]
  );

  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey,
    queryFn: fetchAnalytics,
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
  });

  return {
    data,
    loading: isLoading || isFetching,
    error: error ? (error.message || "Failed to load tax analytics") : null,
    refetch,
  };
}
